import * as Views from "./views";
import * as Wizards from "./wizards";

const Module = {
    name: "contracts",
    defaultRoutePath: "/cars/contract",
    menuItemScope: "fleet",
    menuItemName: "contracts",

    routes: [
        {
            path: "/cars/contract",
            protected: true,
            children: [
                {
                    index: true,
                    path: "",
                    Component: Views.Default,
                },
                {
                    path: "list",
                    Component: Views.List,
                },
            ],
        },
    ],
    drawerRoutes: [
        {
            path: "list",
            Component: Views.List,
        },
        {
            path: "detail",
            Component: Views.Detail,
        },
        {
            path: "create",
            Component: Views.Create,
        },
        {
            path: "serviceDissociation",
            Component: Wizards.ServiceDissociation,
        },
        {
            path: "contractExtension",
            Component: Wizards.ContractExtension,
        },
        {
            path: "removeExtension",
            Component: Wizards.RemoveExtension,
        },
        {
            path: "genericFileAssociation",
            Component: Wizards.GenericFileAssociation,
        },
    ],

}

export default Module;
